var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.75 9.08333C2.75 5.58553 5.58553 2.75 9.08333 2.75C12.5811 2.75 15.4167 5.58553 15.4167 9.08333C15.4167 10.7874 14.7437 12.3343 13.6489 13.4727C13.6165 13.498 13.5852 13.5256 13.5553 13.5554C13.5255 13.5853 13.4979 13.6165 13.4726 13.649C12.3343 14.7437 10.7874 15.4167 9.08333 15.4167C5.58553 15.4167 2.75 12.5811 2.75 9.08333ZM14.2264 15.6407C12.81 16.7532 11.0241 17.4167 9.08333 17.4167C4.48096 17.4167 0.75 13.6857 0.75 9.08333C0.75 4.48096 4.48096 0.75 9.08333 0.75C13.6857 0.75 17.4167 4.48096 17.4167 9.08333C17.4167 11.0242 16.7532 12.81 15.6406 14.2265L18.9571 17.5429C19.3476 17.9334 19.3476 18.5666 18.9571 18.9571C18.5665 19.3476 17.9334 19.3476 17.5428 18.9571L14.2264 15.6407Z","fill":"#FF8E66"}));
}

Search.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Search;

Search.default = Search;
